module.exports = __webpack_public_path__ + "img/CARAC3.e61a586f.jpg";